import { isNative } from "@/lib/capacitor";

export async function tap(): Promise<void> {
  if (!isNative) return;
  const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
  await Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}

export async function notify(success: boolean): Promise<void> {
  if (!isNative) return;
  const { Haptics, NotificationType } = await import("@capacitor/haptics");
  await Haptics.notification({
    type: success ? NotificationType.Success : NotificationType.Error,
  }).catch(() => {});
}
